"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSwitcher = void 0;
const vue_1 = require("vue");
const constants_1 = require("../constants");
const PreferencesManager_1 = require("./PreferencesManager");
exports.LanguageSwitcher = vue_1.default.component('language-switcher', {
    data: function () {
        return {
            'languages': constants_1.LANGUAGES,
        };
    },
    methods: {
        switchLanguageTo: function (langId) {
            PreferencesManager_1.PreferencesManager.save('lang', langId);
            window.location.reload();
        },
    },
    template: `
        <div class="language-switcher">
            <div
                v-for="lang in languages"
                :class="'language-icon language-icon--'+lang.id"
                :title="lang.title"
                v-on:click="switchLanguageTo(lang.id)">&nbsp;</div>
        </div>
    `,
});
//# sourceMappingURL=LanguageSwitcher.js.map